import { render, staticRenderFns } from "./RankingPreferences.vue?vue&type=template&id=e1654ad2&scoped=true&lang=pug&"
import script from "./RankingPreferences.vue?vue&type=script&lang=js&"
export * from "./RankingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1654ad2",
  null
  
)

export default component.exports